import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
    selector: 'app-header',
    imports: [NzGridModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.less'
})
export class HeaderComponent {
  constructor(private readonly router: Router) {}

  navigateToHome(): void {
    this.router.navigate(['']);
  }
}
